import React, { useRef, useState, useEffect } from "react";
import {List , Divider, IconButton, ListItem, ListItemButton,
  ListItemText, ListItemIcon } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeIcon from "@mui/icons-material/Home";
import GroupsIcon from "@mui/icons-material/Groups";
import PeopleIcon from "@mui/icons-material/People";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import ArticleIcon from "@mui/icons-material/Article";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Logout from "@mui/icons-material/Logout";

import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { setItems as setGroupsItems } from '../provider/Slice/GruposSlice';
import { setItems as setUsersItem } from "../provider/Slice/UserSlice";
import { setItems as setInvitacionsItem } from "../provider/Slice/InvitationSlice";
import { setItems as setLicensesItem  } from "../provider/Slice/LicenceSlice";
import { useAppDispatch, useAppSelector } from '../provider/app/hooks';
import { obtenerListadoGrupos, obtenerListadoUsuarios, obtenerListadoInvitaciones, obtenerListadoLicencias, obtenerSesion, cerrarSesion  } from "../service/apiService";
import LogoPico from "../assets/LogoPico.svg";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";


const AdminLayout = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState();
  const [isUserLogged, setUserLogged] = useState(false);
  
  const drawerWidth = 240;

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open", // Evita pasar "open" como prop HTML
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    // Estilos del Drawer interior (el papel visible)
    "& .MuiDrawer-paper": {
      // Aplica estilos según si el Drawer está abierto o cerrado
      ...(open ? openedMixin(theme) : closedMixin(theme)),
    },
  }));

  

  //redirecciona a login si no hay token - si lo hay redirecciona a dashboard
  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (!token && location.pathname !== "/login") {
      navigate("/login");
    }
  
    if (token && location.pathname === "/login") {
      navigate("/");
    }
  
    //para detectar si el usuario se ha logueado
    token ? setUserLogged(true) : setUserLogged(false);

  }, [location]);

  //obtiene informacion del usuario logueado
  useEffect(() => {
    if(isUserLogged)
      getUserInformation();
  }, [isUserLogged])


  //carga los catalogos
  useEffect(() => {
    cargarTodasLasListas();
  }, []);


  const getUserInformation = async() => {
    try
    {
      const response =  await obtenerSesion();
            
      if (response.result)
      {
        setProfile(response.data);
        localStorage.setItem('sesionIniciada', JSON.stringify(response.data));
      }
      else
        navigate("/login");
    }
    catch (error) //ocurre un error
    {
      navigate("/login");
    }
  }

  
  //cierra la sesion del usuario logueado
  const closeSesion = async()=> {
    try {
      localStorage.removeItem("token");
      await cerrarSesion();
      navigate("/login");
    }
    catch(ex){
      console.log({ex})
    }
  }
  
  //controla el menu de "ajustes de cuenta"
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
    
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleDrawer = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //props del menu de "ajustes de cuenta"
  const menuProps = {
    paper: {
      elevation: 0,
      sx: {
        overflow: "visible",
        backgroundColor: "#5d6465",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1,
        },
        "&::before": {
          content: '""',
          display: "block",
          position: "absolute",
          backgroundColor: "#5d6465",
          top: 0,
          right: 14,
          width: 10,
          height: 10,
          transform: "translateY(-50%) rotate(45deg)",
          zIndex: 0,
        },
      },
    },
  };


  const dispatch = useAppDispatch();
  
  const cargarTodasLasListas = async () => {
    try {
      const [grupos, usuarios, invitaciones, licencias] = await Promise.all([
        obtenerListadoGrupos(),
        obtenerListadoUsuarios(),
        obtenerListadoInvitaciones(),
        obtenerListadoLicencias(),
      ]);

      dispatch(setGroupsItems(grupos.data));
      dispatch(setUsersItem(usuarios.data));
      dispatch(setInvitacionsItem(invitaciones.data));
      dispatch(setLicensesItem(licencias.data));
    } catch (error) {
      console.log({ error });
    }
  };


  const menuItems = [
    {
      label: "Dashboard",
      icon: <HomeIcon className="text-amarillo" size="md" />,
    },
    {
      label: "Grupos",
      icon: <GroupsIcon className="text-amarillo" size="md" />,
    },
    {
      label: "Usuarios",
      icon: <PeopleIcon className="text-amarillo" size="md" />,
    },
    {
      label: "Invitaciones",
      icon: <MarkunreadIcon className="text-amarillo" size="md" />,
    },
    {
      label: "Licencias",
      icon: <ArticleIcon className="text-amarillo" size="md" />,
    },
  ];

  const navegarToOpcion = (opcion) => {
    switch (opcion) {

      case "Dashboard" :
        navigate("/admin-suite");
        break;

      case "Grupos" :
        navigate("/admin-suite/groups");
        break;

      case "Usuarios" :
        navigate("/admin-suite/users")
        break;

      case "Invitaciones" :
        navigate("/admin-suite/invitations")
        break;

      case "Licencias" :
        navigate("/admin-suite/licenses")
        break;
    }
  }

  const MenuOptions = (
    <List>
      {menuItems.map((item, index) => (
        <ListItem key={item.label} disablePadding >
          <ListItemButton onClick={ () => navegarToOpcion(item.label) }>
            <ListItemIcon> {item.icon} </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
  
  return (
    <div className="w-full h-screen overflow-y-auto bg-ceniza">
      <nav
        className="block p-3 w-[100%] text-white bg-ceniza shadow-lg"
        style={{ zIndex: 9000, position: "absolute" }}
      >
        <div className="container flex flex-wrap items-center justify-between mx-auto text-gray-100">
          {/* Logo */}
          <a
            href="#"
            className="text-blanco font-worksans text-[20px] font-bold leading-[23px] tracking-[-0.4px] uppercase no-underline flex"
          >
            <img
              className="w-[38px] h-[38px] mx-auto"
              src={LogoPico}
              alt="logo"
            />
            <span className="mt-3 text-[#484d50]"> SmartMine </span>
            <span className="mt-3 text-[#c2a435]"> Code </span>
          </a>

          <div className="hidden lg:block">
            <ul className="flex flex-col gap-2 mt-2 mb-4 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Acerca de
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Contacto
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 ">
                <Link to="/" className="flex items-center">
                  Portafolio
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Preguntas Frecuentes
                </Link>
              </li>

              {/* Informacion personal y cerrar sesion */}
              {isUserLogged &&  (
                <li className="flex items-center p-1 text-sm gap-x-2">
                  <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                    <AccountCircleIcon className="text-amarillo" size="md" />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={openMenu}
                    onClose={handleClose}
                    onClick={handleClose}
                    slotProps={menuProps}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem onClick={handleClose}>
                      <AccountCircleIcon className="text-blanco" size="md"/>
                      <span className="ml-2 text-blanco">  {profile?.name + " " + profile?.surname1 + " " + profile?.surname2} </span>
                    </MenuItem>
                  
                    <Divider />
                    
                    <MenuItem onClick={closeSesion}>
                      <ListItemIcon>
                        <Logout fontSize="small" className="text-blanco" />
                      </ListItemIcon>
                      <span className="text-blanco">  Cerrar Sesión </span>
                    </MenuItem>
                  </Menu>
                </li>
              )}

            </ul>
          </div>
        </div>
      </nav>

      <Drawer
        variant="permanent"
        open={open}
        sx={{
          mt: "40px", // altura de tu Navbar
          "& .MuiDrawer-paper": {
            // Paper interno
            mt: "60px",
            backgroundColor: "#555b5e", // Color de fondo personalizado
            color: "white",
          },
        }}
      >
        <DrawerHeader>
          <span className="text-[#3b4044] font-worksans text-[20px] font-bold ">
            ADMIN
          </span>
          <span className="text-[#bb8a2d] font-worksans text-[20px] font-bold ml-1">
            SUITE
          </span>
          <IconButton onClick={handleDrawer}>
            {!open ? <ChevronRightIcon className="text-blanco"/> : <ChevronLeftIcon className="text-blanco"/>}
          </IconButton>
        </DrawerHeader>

        <Divider />
        
        {MenuOptions}
      
      </Drawer>

      {/* Aquí se insertará la ruta hija */}
      <div className="p-5">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
